import { useEffect, useRef } from "react";

/**
 * Adds an IntersectionObserver to all `.reveal` descendants of a container ref
 * and toggles `.is-visible` once they enter the viewport.
 */
export default function useReveal(rootRef) {
  useEffect(() => {
    const root = rootRef?.current ?? document;
    const targets = root.querySelectorAll(".reveal");
    if (!targets.length) return;

    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("is-visible");
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: "0px 0px -40px 0px" }
    );

    targets.forEach((t) => io.observe(t));
    return () => io.disconnect();
  }, [rootRef]);
}
